import { IdNodeRef, MessagingTopology } from '@internal/open-catalog';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { MessagingExchangeIcon } from '../../../../../../components/icons';

import { MessagingNodeData } from '../flow';
import { BindingsPanel } from './panel.bindings';
import { SelectedPanel } from './panel.selected';

export function InputSourceToolbar(props: {
  data: MessagingNodeData,
  topology: MessagingTopology,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { data, topology, onTopologyChange } = props;
  const { spec } = data;

  const [expanded, setExpanded] = useState<string>('bindings');
  const [source, setSource] = useState<IdNodeRef>();
  const [destination, setDestination] = useState<IdNodeRef>();

  const handleAccordionStateChange = (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const onBindingsChange = (): void => {
    onTopologyChange();
  }

  useEffect(() => {
    setSource(spec);
    setDestination(topology.input);
  }, [spec, topology, setSource, setDestination])

  return (<>
    <SelectedPanel data={data} icon={<MessagingExchangeIcon />} />
    {source && destination && (
      <BindingsPanel data={data} expanded={expanded} onAccordionStateChange={handleAccordionStateChange}
        source={source} destination={destination} onBindingsChange={onBindingsChange}
      />
    )}
  </>);
}